import Wrapper from '@app/Wrapper.js'

Munio.CourseManager = class CourseManager extends Wrapper {
  constructor(selector, classifications, categories, regions) {
    super(selector, {
      classifications,
      categories,
      regions,
    })
  }

  component() {
    return import('./App.vue')
  }
}
